import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsEspressifComponent } from './simple-icons-espressif.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsEspressifComponent ],
    exports:      [ SimpleIconsEspressifComponent ],
    bootstrap:    []
})
export class SimpleIconsEspressifModule {}
